export default __webpack_public_path__ + "img/membership_card_free-e29d8998914c6a3382351e3a89315b74.png";